import {useEffect, useState} from "react";
import {Redirect} from "react-router-dom";
import {getFacebookAuthorizeUrl} from "../../services/api/socialIdentityApi";
import {getApplicationState, setApplicationState} from "../../services/common";
import {genRandomString} from "@okta/okta-auth-js";


const FacebookRedirect = () => {
	const [completed, setCompleted] = useState(false);

	useEffect(() => {
		(async () => {
			try {
				const appState = getApplicationState();
				if(!('facebook' in appState)) {
					appState.facebook = {};
				}

				appState.facebook.state = genRandomString(32);

				setApplicationState(appState);

				const response = await getFacebookAuthorizeUrl(appState.facebook.state);

				if (!response?.data?.data) {
					setCompleted(true);
					return;
				}

				window.location.href = response.data.data;
			}
			catch(_) {
				setCompleted(true);
			}
		})();
	}, []);

	if(completed) {
		return (<Redirect to={'/'} />);
	}

	return (<></>);
}

export default FacebookRedirect;
